import React, { useCallback, useState } from 'react';
import { equals } from 'ramda';
import PropTypes from 'prop-types';
// we don't want the wrapped component - we
// are providing all props.
import { UncomposedSinglePickerField } from './singlePickerField';
import entityComposition from '../../common/classes/entityComposition';
import { getValueAtRemotePath } from '../utils';
import { conformanceSelector, contentSelector, enabledSelector, labelSelector, newPathSelector, valueSelector } from '../selectors';
import logValueOnChange from '../commonActions/logValueOnChange';
const UserSinglePickerField = ({
  path,
  content,
  conformanceText: _conformanceText = null,
  onChange,
  enabled,
  parentContentPath,
  /* eslint-disable-next-line camelcase */
  user: {
    user_id,
    firstName,
    lastName
  },
  setCurrentUserIfNullOnUpdateToContentPath: _setCurrentUserIfNullOnUpdateToContentPath = null,
  value: _value = null,
  className: _className = '',
  onFocus: _onFocus = () => {},
  label: _label = null
}) => {
  const currentUser = {
    /* eslint-disable-next-line camelcase */
    id: user_id,
    title: `${firstName} ${lastName}`
  };
  let currentValueInContent = _value;
  if (_setCurrentUserIfNullOnUpdateToContentPath) {
    currentValueInContent = getValueAtRemotePath(path, _setCurrentUserIfNullOnUpdateToContentPath, content);
  }
  const [contentValueDuringLastRender, setCurrentContentValue] = useState(currentValueInContent);
  if (!equals(contentValueDuringLastRender, currentValueInContent) && currentValueInContent) {
    setCurrentContentValue(currentValueInContent);
    if (!_value) {
      onChange({
        path,
        value: currentUser
        // prev values are null
      });
    }
  }

  // If the selected user is an other selection then the id
  // will come in as identifier, not id so we need to do some
  // massaging.
  const trueValue = _value ? {
    title: _value.title,
    id: _value.id || _value.identifier
  } : null;
  const handleChange = useCallback(({
    path: fieldPath,
    value: data
  }) => {
    if (!data) {
      return onChange({
        path: fieldPath,
        value: null
      });
    }
    if (data.id) {
      return onChange({
        path: fieldPath,
        value: data,
        displayValue: data.title
      });
    }
    const newValue = {
      identifier: data.identifier,
      title: data.title,
      id: null
    };

    // ensure the `id` value is cleared when handling 'other' data
    return onChange({
      path: fieldPath,
      value: newValue,
      displayValue: newValue.title
    });
  }, [onChange]);
  return /*#__PURE__*/React.createElement(UncomposedSinglePickerField, {
    value: trueValue,
    valueKey: "id",
    label: _label,
    otherKey: "identifier",
    allowsOther: true,
    options: [currentUser],
    onChange: handleChange,
    className: _className,
    conformanceText: _conformanceText,
    enabled: enabled,
    path: path,
    onFocus: _onFocus,
    parentContentPath: parentContentPath
  });
};
UserSinglePickerField.propTypes = {
  conformanceText: PropTypes.string,
  setCurrentUserIfNullOnUpdateToContentPath: PropTypes.string,
  value: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    identifier: PropTypes.string
  }),
  path: PropTypes.string.isRequired,
  label: PropTypes.string,
  enabled: PropTypes.bool.isRequired,
  className: PropTypes.string,
  parentContentPath: PropTypes.string.isRequired,
  content: PropTypes.shape({}).isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  user: PropTypes.shape({
    user_id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string
  }).isRequired
};
export { UserSinglePickerField as UncomposedUserSinglePickerField };
export default entityComposition(UserSinglePickerField, [], {
  conformanceText: conformanceSelector,
  user: state => state.login.user,
  value: valueSelector,
  enabled: enabledSelector,
  path: newPathSelector,
  onChange: logValueOnChange,
  content: contentSelector,
  label: labelSelector
});